import { type CSSProperties } from 'react';
import styles from './divider.module.scss';

const Divider = ({ margin }: IProps) => {
	return (
		<hr
			className={styles.divider}
			style={
				{ '--divider-margin': margin || 'var(--spacing-m)' } as CSSProperties
			}
		/>
	);
};

export default Divider;

interface IProps {
	margin?: string | number;
}
